import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { editCapacityLevelRequest } from '../requests/editCapacityLevelRequest';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useEditCapacityLevel() {
	const navigate = useNavigate();

	const editCapacityLevel = useMutation({
		mutationFn: async (data: any) => {
			return editCapacityLevelRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully edited!', type: 'success' });
			queryClient.invalidateQueries(['CAPACITY_LEVEL_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { editCapacityLevel };
}
